import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from './pipes/translate.pipe';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { NavigateDirective } from './navigate.directive';
import { MatchesDirective } from '../matches.directive';
import { HeaderBarComponent } from './header-bar/header-bar.component';
import { HttpClientModule } from '@angular/common/http';
import { InfoComponent } from '../tour/info/info.component';
import { AudioDirective } from '../audio.directive';
import { FocusDirective } from '../tour/info/directives/focus.directive';
import { QuizComponent } from '../tour/info/quiz/quiz.component';
import { ReflectionComponent } from '../tour/info/reflection/reflection.component';
import { TestComponent } from '../tour/info/test/test.component';
import { TimebarComponent } from '../tour/info/timebar/timebar.component';
import { ZoomDirective } from '../zoom.directive';
import { PageLayoutComponent } from 'src/app/page-layout/page-layout.component'
import { WelcomeTourStopComponent } from '../tour/info/welcome-tour-stop/welcome-tour-stop.component';
import { SafepipePipe } from './pipes/safepipe.pipe';
import { VideoComponent } from '../tour/info/video/video.component'
import { LottieModule } from 'ngx-lottie';
export function playerFactory() {
  return import('lottie-web');
}

@NgModule({
  declarations: [
    TranslatePipe,
    SideMenuComponent,
    NavigateDirective,
    MatchesDirective,
    HeaderBarComponent,
    InfoComponent,
    TimebarComponent,
    QuizComponent,
    WelcomeTourStopComponent,
    AudioDirective,
    ReflectionComponent,
    TestComponent,
    ZoomDirective,
    FocusDirective,
    PageLayoutComponent,
    SafepipePipe,
    VideoComponent
  ],
  imports: [CommonModule, HttpClientModule, LottieModule.forRoot({player: playerFactory}),],
  exports: [
    TranslatePipe,
    SafepipePipe,
    SideMenuComponent,
    NavigateDirective,
    MatchesDirective,
    HeaderBarComponent,
    TimebarComponent,
    QuizComponent,
    AudioDirective,
    ReflectionComponent,
    WelcomeTourStopComponent,
    TestComponent,
    ZoomDirective,
    FocusDirective,
    HttpClientModule,
    InfoComponent,
    PageLayoutComponent,
    VideoComponent
  ],
})
export class SharedModule {}
